var $body = $("body"),
  $doc = $(document);
async function checkUserLocation() {
  if (!sessionStorage.getItem("noti-popup-custom")) {
    try {
      // const response = await fetch("https://ssl.geoplugin.net/javascript.gp?k=9247556ec91c71e9");
      $.getScript(
        "https://ssl.geoplugin.net/javascript.gp?k=9247556ec91c71e9",
        function () {
          var newCurrency = geoplugin_countryCode();
          if (newCurrency !== "US" && newCurrency !== "CA") {
            $body.addClass("notify-custom-show");
            sessionStorage.setItem("noti-popup-custom", true);
          }
        }
      );
    } catch (error) {
      console.error("Error fetching location data:", error);
    }
  }
}
document.addEventListener("DOMContentLoaded", checkUserLocation);

$doc.on("click", "[data-close-notify-custom-popup]", (event) => {
  event.preventDefault();
  event.stopPropagation();
  $body.removeClass("notify-custom-show");
});

$doc.on("click", (event) => {
  if ($body.hasClass("notify-custom-show")) {
    if (
      $(event.target).closest("[data-notify-custom-popup]").length === 0 &&
      $(event.target).hasClass("background-overlay")
    ) {
      $body.removeClass("notify-custom-show");
    }
  }
});
